<script>
    import { Paper } from "@svelteuidev/core";
    import { onMount } from "svelte";
    import Conexoes from "../Classes/Conexoes";
    import Constantes from "../Classes/Constantes.js";
    import { DadosLogin, permissaoUsuario } from "../Classes/Stores";
    import LoadingTela from "../componentes_basicos/LoadingTela.svelte";
    import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
    import TelasAcessoNaoAutorizado from "../Telas/TelasAcessoNaoAutorizado.svelte";
    export let params;
    let id_campeonato = params;
    let api = Constantes.api_consultar_padrao;
    let message;
    let id_usuario = $DadosLogin.id_usuario;

    let parametros = {
        id_usuario: id_usuario,
        id_campeonato: id_campeonato,
        query_code: Constantes.query_code_consultar_ingressos,
    };

    let conexoes = new Conexoes();
    let minhasInscricoes = [];
    let isLoading = false;
    let checkins = [];
    let cod;
    let confirmaCheckinModal = false;

    function confirmaCheckin(e) {
        cod = e;
        confirmaCheckinModal = true;
        confirma();
    }

    async function confirma() {
        // Código para o checkin no banco
        isLoading = true;
        let result = await conexoes.conecta(
            Constantes.api_inserir_sem_query_code,
            {
                id_inscricao: cod,
                tabela: "registro_ingresso",
            },
            null,
            "Deseja Registrar o ingresso?",
        );

        if (result && result.sucesso) {
            message = Constantes.msg_inserido_sucesso;
            window.location.reload();
        } else if (result) {
            message = Constantes.msg_erro_conexao_bd;
        }
        isLoading = false;
        confirmaCheckinModal = false;
    }

    function cancela() {
        confirmaCheckinModal = false;
    }

    export async function conectar() {
        isLoading = true;
        minhasInscricoes = await conexoes.conecta(api, parametros);
        isLoading = false;

        if (minhasInscricoes) {
            let nomes = [];
            let linhas = {};
            let p = {};
            let parametro = {};
            let p2 = [];
            minhasInscricoes.forEach((element) => {
                p = {
                    inserido_em: element.inserido_em,
                    qtd_registro: element.qtd_registro,
                };
                p2 = [p];
                if (!nomes.includes(element.nome_inscrito)) {
                    parametro = {
                        inscrito1: element.nome_inscrito,
                        nome_equipe: element.nome_equipe,
                        nome_categoria: element.nome_categoria,
                        cod_inscricao_encurtado:
                            element.cod_inscricao_encurtado,
                        id_inscricao: element.id,
                        registros: p2,
                    };
                    linhas[element.nome_inscrito] = [parametro];
                    nomes = [...nomes, element.nome_inscrito];
                } else {
                    linhas[element.nome_inscrito][0].registros = [
                        ...linhas[element.nome_inscrito][0].registros,
                        p,
                    ];
                }
            });

            checkins = Object.values(linhas);
        }
    }

    onMount(async () => {
        await id_usuario;

        await conectar();
        filtrarCheckins();
        check = checkins;
    });
    let filtro = "";
    let check = checkins;
    function filtrarCheckins() {
        // Se o filtro estiver vazio, retorna todos os check-ins
        if (!filtro) {
            console.log(checkins);
            check = checkins;
        } else {
            check = checkins.filter((linhas) =>
                linhas.some((l) =>
                    Object.values(l)
                        .join(" ")
                        .toLowerCase()
                        .includes(filtro.toLowerCase()),
                ),
            );
        }

        // Caso contrário, aplica o filtro
    }

    function MudaCor(l) {
        if (
            l.nome_categoria.toLowerCase().includes("2 dias") &&
            l.registros.length == 1 &&
            l.registros[0].inserido_em != null
        ) {
            return "amarelo";
        } else if (
            (l.nome_categoria.toLowerCase().includes("2 dias") &&
                l.registros.length > 1) ||
            (l.nome_categoria.toLowerCase().includes("1 dia") &&
                l.registros.length > 0 &&
                l.registros[0].inserido_em != null)
        ) {
            return "vermelho";
        }
    }
</script>

<CaixaDeDialogo {message} on:close={() => (message = "")} />
<LoadingTela {isLoading} />
<br />
<br />
{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_registrar_ingressos)}
    <div class="margem">
        <div class="fonte">
            <strong>Registrar presença</strong>
        </div>
        <div class="margem">
            <input
                type="text"
                placeholder="Filtrar por nome, equipe, categoria..."
                bind:value={filtro}
                class="inputFiltro"
                on:input={filtrarCheckins}
            />
        </div>
        {#if check.length > 0}
            <table class="tabela-checkin">
                <thead>
                    <tr>
                        <th>ID</th> <th>Nome(s)</th>
                        <th>Categoria</th>
                        <th>Inscrição</th>
                        <th>Registros</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {#each check as linhas}
                        {#each linhas as l}
                            <tr class={MudaCor(l)}>
                                <td>{l.id_inscricao}</td>
                                <td>{l.inscrito1}</td>
                                <td>{l.nome_categoria}</td>
                                <td>{l.cod_inscricao_encurtado}</td>
                                <td>
                                    {#each l.registros as registro}
                                        {#if registro.inserido_em != null}
                                            {registro.inserido_em}<br />
                                        {/if}
                                    {/each}
                                </td>
                                <td>
                                    {#if (l.nome_categoria
                                        .toLowerCase()
                                        .includes("2 dias") && l.registros.length > 1) || (l.nome_categoria
                                            .toLowerCase()
                                            .includes("1 dia") && l.registros.length > 0 && l.registros[0].inserido_em != null)}
                                        <button
                                            class="buttonCinza"
                                            on:click={() =>
                                                confirmaCheckin(l.id_inscricao)}
                                            disabled="true"
                                        >
                                            Registrar Presença
                                        </button>
                                    {:else}
                                        <button
                                            class="buttonAzul"
                                            on:click={() =>
                                                confirmaCheckin(l.id_inscricao)}
                                        >
                                            Registrar Presença
                                        </button>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    {/each}
                </tbody>
            </table>
        {:else}
            <h1>Sem presenças a realizar. Recarregue</h1>
        {/if}
    </div>
{:else}
    <TelasAcessoNaoAutorizado />
{/if}
<br />
<br />
<br />
<br />

<style>
    button {
        font-family: "Roboto", sans-serif;
        font-size: 1rem;
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 4px;
        color: white;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .buttonAzul {
        background-color: #1976d2;
    }
    .buttonCinza {
        background-color: #a3a8ad;
    }
    .buttonVermelho {
        background-color: #ee7171;
    }

    .buttonVerde {
        background-color: #67ca7b;
    }

    .modal {
        display: block;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.4);
    }
    .vermelho {
        background-color: rgb(249, 169, 169);
    }
    .amarelo {
        background-color: rgb(245, 245, 161);
    }
    .modal-content {
        background-color: #fefefe;
        margin: 15% auto;
        padding: 20px;
        border: 1px solid #888;
        width: 40%;
    }

    .margem {
        margin-top: 70px;
        margin-left: 20px;
        margin-right: 20px;
        margin-bottom: 20px;
    }

    .fonte {
        font-size: 30px;
        font-weight: bold;
        color: #000080;
        text-align: center;
    }

    .tabela-checkin {
        width: 100%;
        border-collapse: collapse;
    }

    .tabela-checkin th,
    .tabela-checkin td {
        border: 1px solid #ddd;
        padding: 8px;
    }

    .tabela-checkin th {
        background-color: #f2f2f2;
        text-align: left;
    }
    .margem {
        margin-top: 70px;
        margin-left: 20px;
        margin-right: 20px;
        margin-bottom: 20px;
    }

    .fonte {
        font-size: 30px;
        font-weight: bold;
        color: #000080;
        text-align: center;
    }
    .inputFiltro {
        width: 100%;
        padding: 10px;
        margin-bottom: 20px;
        font-size: 1.2rem;
        border: 1px solid #ccc;
        border-radius: 5px;
    }
</style>
